"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    const hasColumn = await knex.schema.hasColumn(_globals.MetaTable.FILTER_EXP, 'fk_button_col_id');
    if (!hasColumn) {
        await knex.schema.alterTable(_globals.MetaTable.FILTER_EXP, (table)=>{
            table.string('fk_button_col_id', 20);
            table.index('fk_button_col_id');
        });
    }
};
const down = async (knex)=>{
    const hasColumn = await knex.schema.hasColumn(_globals.MetaTable.FILTER_EXP, 'fk_button_col_id');
    if (hasColumn) {
        await knex.schema.alterTable(_globals.MetaTable.FILTER_EXP, (table)=>{
            table.dropIndex('fk_button_col_id');
            table.dropColumn('fk_button_col_id');
        });
    }
};
